/**
 * Personality traits, as they are actually stored.
 *
 * There is no traits column. A Genie's personality lives as one managed line
 * inside its system prompt, so the owner can read and edit it like any other
 * instruction. Extracted from `SetupPopout` so the /welcome onboarding step
 * writes traits exactly the same way rather than inventing a second scheme.
 */

export const TRAIT_OPTIONS = [
  "Professional",
  "Friendly",
  "Empathetic",
  "Direct",
  "Patient",
  "Energetic",
] as const;

export type TraitLabel = (typeof TRAIT_OPTIONS)[number];

export const TRAITS_MARKER = "Personality traits:";

/** Build the trait sentence appended to the system prompt. */
export const buildTraitLine = (active: readonly TraitLabel[]): string =>
  active.length ? `${TRAITS_MARKER} ${active.map((t) => t.toLowerCase()).join(", ")}.` : "";

/** Remove any previously-managed trait line so a clean one can be written. */
export const stripTraitLine = (prompt: string): string =>
  prompt
    .split("\n")
    .filter((line) => !line.trim().startsWith(TRAITS_MARKER))
    .join("\n")
    .trimEnd();

/** Read the traits currently written into a system prompt. */
export const readTraits = (prompt: string): TraitLabel[] =>
  TRAIT_OPTIONS.filter((t) => prompt.toLowerCase().includes(t.toLowerCase()));
